import { Component, OnInit, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Title } from '@angular/platform-browser';
import { ToolEnum } from 'src/Models/Common';
import { stateMasterModel } from 'src/Models/VoipModel';
import { voipService } from 'src/Services/voip.service';
import { CheckAuth } from 'src/Services/utility.service';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-voip-my-favorites',
  templateUrl: './voip-my-favorites.component.html',
  styleUrls: ['./voip-my-favorites.component.css']
})
export class VoipMyFavoritesComponent implements OnInit {
  userID: number = 0;
  appModel: any;
  isloading: boolean = false;
  tokenKey: string = '';

  dropdownListState = [];
  selectedItemsState = [];
  dropdownSettingsState = {};
  listOfStateId: number[] = [];
  stateFilter: string = '';
  favouriteStateModel: stateMasterModel[] = [];

  isShowprogressSpinner: boolean;
  blockedDocument: boolean = false;

  productId: number;
  baseUrl: string;

  statusCode: any;
  ValidationMessage: string;
  DeSelectedFavoriteId: number = 0;

  voipUnreadflag:boolean=true;
  voipUnread: number = 0;

  constructor(@Inject('BASE_URL') baseUrl: string,
    private readonly toastr: ToastrService, 
    private readonly voipService: voipService, 
    private readonly titleService: Title,
    private readonly checkAuth: CheckAuth,
    private sessionStorageService: SessionStorageService) {
    this.userID = +sessionStorage.getItem('UserId');
    this.baseUrl = baseUrl;
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.productId = ToolEnum.voip;
    this.titleService.setTitle('My Favorites | JSi360');

    // Try to get token
    this.waitForTokenThenInit();
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  private waitForTokenThenInit(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();

    if (!this.tokenKey) {
      console.warn('Token is empty, retrying in 100ms...');
      const interval = setInterval(() => {
        this.tokenKey = this.sessionStorageService.getTokenValue();
        if (this.tokenKey) {
          clearInterval(interval);
          this.afterTokenReady();
        }
      }, 100); // check every 100ms
    } else {
      this.afterTokenReady();
    }
  }

  /** Call what you normally do in ngOnInit */
  private afterTokenReady(): void {
    this.voipUnreadflag = true;
    let voipReadflag= sessionStorage.getItem('voipUnreadflag');
    this.voipUnreadflag = voipReadflag === 'true' ? true : false;

    let voipUnreadcount= sessionStorage.getItem('voipUnread');

    this.voipUnread=parseInt(voipUnreadcount);

    this.GetStateData();
  }

  ngOnInit() {
    
  }

  GetStateData(): void {
    this.listOfStateId = [];
    this.dropdownListState = [];
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.voipService.GetMatrixStatesByUserID(this.tokenKey, this.userID, this.productId).subscribe(
      data => {
        if (data["state"] != null) {
          this.selectedItemsState = [];
          for (let iCounter = 0; iCounter < data["state"].length; iCounter++) {
            this.dropdownListState.push(
              { "id": data["state"][iCounter].stateId, "itemName": data["state"][iCounter].name }
            );

            if (data["state"][iCounter].isActionFavorite == true) {
              this.selectedItemsState.push({ "id": data["state"][iCounter].stateId, "itemName": data["state"][iCounter].name });
              this.listOfStateId.push(data["state"][iCounter].stateId);
            }

          }

          this.favouriteStateModel = data["state"].filter(book => book.isActionFavorite === true);
        }
        else {
          this.showMessage(data["message"], 'Error', 'error');
          this.unblockDocument();
        }
        this.dropdownSettingsState = {
          singleSelection: false,
          text: "Select State(s)",
          enableSearchFilter: true,
          classes: "borderLessTextBoxGreen",
          badgeShowLimit: 1,
          noDataLabel: 'No state available',
          showCheckbox: true,
          enableFilterSelectAll: false,
          enableCheckAll: true
        };
      }, error => {
        this.showMessage(error, 'Error', 'error');
        this.unblockDocument();
      })
  }

  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }

  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  SaveUserPrefrences(IsSelected:number) {
    this.voipService.SaveUserPrefrences(this.tokenKey, this.stateFilter, this.userID, this.productId).subscribe(
      data => {
        if (IsSelected == 1) {
          this.showMessage('Selected state Added successfully from favorite list.', 'Favorite', 'success');
        }
        else {
          this.showMessage('Selected state removed successfully from favorite list.', 'Favorite', 'success');
        }
        this.GetStateData();
      },
      error => {
        this.statusCode = error;
      }
    );
  }

  removeElemetninArray(array, element) {
    return array.filter(e => e !== element);
  }

  OnSelectState($event) {
    if (this.listOfStateId != null) {
      if (this.listOfStateId.length > 0) {
        this.listOfStateId = this.removeElemetninArray(this.listOfStateId, $event.id)
        this.listOfStateId.push($event.id);
      }
      else {
        this.listOfStateId.push($event.id);
      }
    }
    this.stateFilter = this.listOfStateId.join(',');
    this.SaveUserPrefrences(1);
  }

  OnDeSelectState($event) {
    if (this.listOfStateId != null) {
      if (this.listOfStateId.length > 0) {
        this.listOfStateId = this.removeElemetninArray(this.listOfStateId, $event.id)
      }
    }
    this.stateFilter = this.listOfStateId.join(',');
    if (this.listOfStateId.length == 0)
      this.stateFilter = 'null';
    this.SaveUserPrefrences(0);
  }

  onSelectAllStateList($event) {
    for (let iCounter = 0; iCounter < $event.length; iCounter++) {
      if (this.listOfStateId != null) {
        if (this.listOfStateId.length > 0) {
          this.listOfStateId = this.removeElemetninArray(this.listOfStateId, $event[iCounter].id)
          this.listOfStateId.push($event[iCounter].id);
        }
        else {
          this.listOfStateId.push($event[iCounter].id);
        }
      }
    }
    this.stateFilter = this.listOfStateId.join(',');
    this.SaveUserPrefrences(1);
  }

  onDeSelectAllStateList($event) {
    this.listOfStateId = [];
    this.stateFilter = this.listOfStateId.join(',');
    if (this.listOfStateId.length == 0)
      this.stateFilter = 'null';
    this.SaveUserPrefrences(0);
  }

  RemoveStarFavorite(id: number, Type: string) {
    this.DeSelectedFavoriteId = id;
    if (Type == 'state') {
      this.ValidationMessage = "Are you sure you want to remove selected state from favorite list?"
    }
    var elem = document.getElementById("lnkFavouriteValidation");
    elem.click();
  }

  DeselectFavourite() {    
    this.voipService.RemoveMatrixFavoriteByUserID(this.tokenKey, this.userID, this.productId, this.DeSelectedFavoriteId).subscribe(
      data => {
        this.DeSelectedFavoriteId = 0;
        if (data['status'] == 'Success') {
          this.showMessage('Selected state removed successfully from favorite list.', 'Favorite', 'success');
          this.GetStateData();
          document.getElementById("btnClose").click();
        }
      }
      , error => {
        document.getElementById("btnClose").click();
      }
    );
  }

}
